import './App.css';
import { jwtDecode } from "jwt-decode";
import Navigation from './UI/Pages/navigation';
import FormulaireConnexion from './UI/Pages/FormulaireConnexion/formulaireConnexion';
import RenouvellementJeton from './services/renouvellement-jeton.service';
import AppelerApi from './services/appeler-api.service';
import React, { useState, useEffect, createContext } from 'react';
import websocketService from './services/websocket.service';
import notificationService from './services/notification.service';

export const baseSelectionneeContext = createContext(null);

function App() {
    const [estConnecte, setEstConnecte] = useState(false);
    const [environnementsDisponibles, setEnvironnementsDisponibles] = useState({});

    const valeurBase = localStorage.getItem('baseSelectionnee') ?? ((window.location.hostname.includes('localhost') || window.location.hostname.includes('crm')) ? 'DEV' : 'PROD');
    localStorage.setItem('baseSelectionnee', valeurBase);
    const [baseSelectionnee, setBaseSelectionnee] = useState(valeurBase);


    const couleurEnvironnement = () => {
        if (!environnementsDisponibles[baseSelectionnee]) {
            return { backgroundColor: '#FFFFFF' };
        }
        return { backgroundColor: environnementsDisponibles[baseSelectionnee].backgroundCSS };
    };

    AppelerApi.enregistrerMethodeDeconnexion(() => {
        localStorage.removeItem('jeton');
        setEstConnecte(false);
    });

    RenouvellementJeton.lancerRenouvellementJeton();

    const verifierJeton = () => {
        const jeton = localStorage.getItem('jeton');
        if (jeton) {
            try {
                const jetonDecode = jwtDecode(jeton);
                if (jetonDecode.exp * 1000 < Date.now()) {
                    localStorage.removeItem('jeton');
                    setEstConnecte(false);
                } else {
                    setEstConnecte(true);
                }
            } catch (error) {
                console.error('Jeton invalide', error);
                localStorage.removeItem('jeton');
                setEstConnecte(false);
            }
        }
    }

    useEffect(() => {
        const intervalId = setInterval(verifierJeton, 60000);

        verifierJeton();

        AppelerApi.get('/lire-environnements-disponibles').then(environnements => {
            setEnvironnementsDisponibles(environnements);
        });

        return () => clearInterval(intervalId);
    }, []);

    const gererConnexion = (params) => {
        for (const [clef, valeur] of Object.entries(params)) {
            localStorage.setItem(clef, valeur);
        }
        websocketService.connecterWebSocket(true);
        setEstConnecte(true);
        notificationService.demander();
    };

    const gererDeconnexion = () => {
        localStorage.removeItem('jeton');
        websocketService.deconnecterWebSocket();
        setEstConnecte(false);
    };


    return (
        <div className={'App'} style={couleurEnvironnement()}>
            <baseSelectionneeContext.Provider value={{baseSelectionnee, setBaseSelectionnee}}>
                {estConnecte && environnementsDisponibles && environnementsDisponibles.DEV ? (
                    <Navigation surDeconnexion={gererDeconnexion} environnementsDisponibles={environnementsDisponibles} />
                ) : (
                    <FormulaireConnexion surConnexion={gererConnexion} />
                )}
            </baseSelectionneeContext.Provider>
        </div>
    )

}

export default App;
